var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBikeWashInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.35,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51367 6.33915C5.51367 6.09259 5.77601 5.89272 6.09961 5.89272H7.97461C8.29821 5.89272 8.56055 6.09259 8.56055 6.33915V9.82129H9.87891C10.2025 9.82129 10.4648 10.0212 10.4648 10.2677C10.4648 10.5143 10.2025 10.7141 9.87891 10.7141H5.83594C5.51233 10.7141 5.25 10.5143 5.25 10.2677C5.25 10.0212 5.51233 9.82129 5.83594 9.82129H7.38867V6.78557H6.09961C5.77601 6.78557 5.51367 6.5857 5.51367 6.33915Z",
    fill: "#127E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85742 4.99986C7.672 4.99986 7.49075 4.95797 7.33657 4.87948C7.1824 4.801 7.06224 4.68944 6.99128 4.55892C6.92033 4.4284 6.90176 4.28478 6.93794 4.14622C6.97411 4.00767 7.0634 3.88039 7.19451 3.7805C7.32562 3.6806 7.49267 3.61258 7.67452 3.58501C7.85638 3.55745 8.04488 3.5716 8.21619 3.62566C8.38749 3.67972 8.53391 3.77128 8.63692 3.88874C8.73994 4.0062 8.79492 4.1443 8.79492 4.28558C8.79492 4.47502 8.69615 4.6567 8.52033 4.79065C8.34452 4.92461 8.10606 4.99986 7.85742 4.99986Z",
    fill: "#127E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeWashInfo);
export default __webpack_public_path__ + "static/media/BikeWashInfo.48015eb4.svg";
export { ForwardRef as ReactComponent };